var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withFieldMetadata } from '../enhancers/withFieldMetadata';
import { withEmptyFieldEditingComponent } from '../enhancers/withEmptyFieldEditingComponent';
import { DefaultEmptyFieldEditingComponentText } from './DefaultEmptyFieldEditingComponents';
import { isFieldValueEmpty } from '@sitecore-jss/sitecore-jss/layout';
export const RichText = withFieldMetadata(withEmptyFieldEditingComponent(
// eslint-disable-next-line react/display-name
forwardRef((_a, ref) => {
    var { field, tag = 'div', editable = true } = _a, otherProps = __rest(_a, ["field", "tag", "editable"]);
    if (!field || (!field.editable && isFieldValueEmpty(field))) {
        return null;
    }
    const htmlProps = Object.assign({ dangerouslySetInnerHTML: {
            __html: field.editable && editable ? field.editable : field.value,
        }, ref }, otherProps);
    return React.createElement(tag || 'div', htmlProps);
}), { defaultEmptyFieldEditingComponent: DefaultEmptyFieldEditingComponentText, isForwardRef: true }), true);
export const RichTextPropTypes = {
    field: PropTypes.shape({
        value: PropTypes.string,
        editable: PropTypes.string,
        metadata: PropTypes.objectOf(PropTypes.any),
    }),
    tag: PropTypes.string,
    editable: PropTypes.bool,
    emptyFieldEditingComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]),
};
RichText.propTypes = RichTextPropTypes;
RichText.displayName = 'RichText';
